import React, { FC } from "react";
import { Select, Box, Text, SelectComponentOption } from "common/components/ui";
import { map } from "lodash";
import { FormattedMessage } from "common/components/ui/FormattedMessage";
import { selectEcomDestinationLabels } from "./SelectEcomDestinationLabels";
import { OptionProps, SingleValueProps } from "@deliverr/react-select-v1";
import styled from "@emotion/styled";
import { DistributionChannel } from "@deliverr/replenishment-client";

const StyledBox = styled(Box)`
  color: #000;
`;

interface SelectEcomDestinationProps {
  selectedDestination: DistributionChannel | undefined;
  destinations: readonly DistributionChannel[];
  onChange: (value: string) => void;
}

const OptionContent = ({ label, description }) => (
  <StyledBox paddingTop="S1" paddingBottom="S1">
    <Text>{label}</Text>
    <Text appearance="INFO" size="caption">
      {description}
    </Text>
  </StyledBox>
);

const Option: FC<OptionProps> = (props) => (
  <SelectComponentOption {...props}>
    <OptionContent label={props.data.label} description={props.data.description} />
  </SelectComponentOption>
);

const SingleValue: FC<SingleValueProps<any>> = (props) => (
  <OptionContent label={props.data.label} description={props.data.description} />
);

export const SelectEcomDestination: FC<SelectEcomDestinationProps> = ({
  selectedDestination,
  destinations,
  onChange,
}) => {
  const options = map(destinations, (destination) => ({
    value: destination,
    label: <FormattedMessage {...selectEcomDestinationLabels.ecomDestination[destination]} />,
    description: <FormattedMessage {...selectEcomDestinationLabels.ecomDescription[destination]} />,
  }));

  return (
    <Box marginTop="S1" data-testid="select-ecom-destination">
      <Select
        value={options.find((opt) => opt.value === selectedDestination)}
        options={options}
        onChange={(option) => onChange(option?.value)}
        placeholder={<FormattedMessage {...selectEcomDestinationLabels.placeholder} />}
        customComponents={{ Option, SingleValue }}
        isSearchable={false}
      />
    </Box>
  );
};
